import React, { useState } from 'react'
import { Drawer } from 'antd'
import { useSelector } from 'react-redux'

import { SaleItem } from './newBill'

const Variants = ({ item, visible, toggle }) => {
    const [string, setString] = useState('')

    const { order } = useSelector(state => state.order)

    return (
        <Drawer
            closable
            maskClosable
            drawerStyle={{ backgroundColor: '#f3f3f3' }}
            visible={visible}
            onClose={toggle}
            width="60%">
            <p className="font-extrabold text-3xl mb-0">{ item?.name }</p>
            <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
                <div className="flex justify-center items-center mb-8">
                    <input
                        onChange={e => setString(e.target.value)}
                        className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-first-name"
                        type="text"
                        placeholder="Type to search items" />
                </div>
                <div className="grid grid-cols-2 pb-7 md:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 mt-4 gap-x-4 gap-y-4">
                    {
                        (item?.variants ? item?.variants : [])
                            .filter((variant) => variant.name.toLowerCase().includes(string.toLowerCase()))
                            .map((variant, key) =>
                                <SaleItem
                                    i={key}
                                    item={ variant }
                                    selectItem={() => null}
                                    order={order} />
                            )
                    }
                </div>
            </div>
        </Drawer>
    )
}

export default Variants